import React, {useEffect} from 'react'
import {Container} from 'reactstrap'
import { useHistory } from "react-router-dom"

import Header from 'common/Header'
import { isAdmin } from "utils/UserHelper"

const Index = () => {
  const history = useHistory()
  useEffect(() => {
    if(isAdmin()){
      history.push('/admin')
    }
  }, [])

  return (
    <div>
      <Header />
      <Container className="container-dashboard">
        <h1 className="text-center mt-4">Welcome to <span className="color-accent">Nexogic</span> App</h1>
      </Container>
    </div>
  )
} 

export default Index